import axios from "axios";
import { useState } from "react";

import "./Contact.css"

const initialState = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

const Contact = () => {
  const [formData, setFormData] = useState(initialState);
  const { name , email, subject, message } = formData;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  };

  const requestContact = async (e) => {
    e.preventDefault();

    try {
      const emailData = {
        name,
        email,
        subject,
        message,
        templateId: "d-7bb751abdb0e48be9825a0f18fa489cd",
      };

      const response = await api.post('/api/users/sendCustomEmail', emailData);

      if (response.status === 200) {
        window.alert("Message sent successfully!");
        setFormData(initialState);
      }
    } catch (error) {
      alert("Failed to send message. Please try again.");
    };
  }

  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">Get In Touch</h2>

      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything!</h3>
          <p className="contact__details">Don't like forms? Send me an email. 👋</p>
        </div>

        <form
          action=""
          className="contact__form"
          onSubmit={requestContact}
        >
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="name"
                value={name}
                onChange={handleInputChange}
                className="contact__form-input"
                placeholder="Insert your name"
              />
            </div>

            <div className="contact__form-div">
              <input
                type="email"
                name="email"
                value={email}
                onChange={handleInputChange}
                className="contact__form-input"
                placeholder="Insert your email"
              />
            </div>
          </div>

          <div className="contact__form-div">
            <input
              type="text"
              name="subject"
              value={subject}
              onChange={handleInputChange}
              className="contact__form-input"
              placeholder="Insert your subject"
            />
          </div>

          <div className="contact__form-div contact__form-area">
            <textarea
              name="message"
              value={message}
              onChange={handleInputChange}
              id=""
              cols="30"
              rows="10"
              className="contact__form-input"
              placeholder="Write your message"
            >
            </textarea>
          </div>  

          <button type="submit" className="btn">Send Your Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact